<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-11 16:03:56
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-12 17:45:28
 * @FilePath: \hzs-nutra-wecom-shop\src\views\live\liveDetail\components\liveDetailInfo.vue
 * @Description: 直播详情 - 直播详情
-->

<template>
  <div class="activity_detail_info h100">
    <div class="card">
      <div class="flex">
        <div class="title">{{ state.live.title }}</div>
        <div class="status">{{ getStatus(state.live.status) }}</div>
      </div>

      <div class="time t1">
        {{ state.live.startTime }} ~ {{ state.live.endTime }}
      </div>

      <div class="time">
        {{ state.live.desc }}
      </div>

      <van-divider></van-divider>

      <div class="commonText">
        <div class="label">奖励规则：</div>
        <div class="value">{{ state.live.aaaaaa }}</div>
      </div>
      <div class="commonText">
        <div class="label">直播规范：</div>
        <div class="value">{{ state.live.aaaaaa }}</div>
      </div>
      <div class="commonText">
        <div class="label">可观看客户标签：</div>
        <div class="value">{{ state.live.aaaaaa }}</div>
      </div>
      <div class="commonText">
        <div class="label">观看密码：</div>
        <div class="value">{{ state.live.aaaaaa }}</div>
      </div>
      <div class="commonText">
        <div class="label">直播商品：</div>
        <div class="value">{{ state.live.aaaaaa }}</div>
      </div>

      <van-divider></van-divider>

      <div class="commonText">
        <div class="label">达标时长：</div>
        <div class="value">{{ state.live.aaaaaa }}</div>
      </div>
      <div class="commonText">
        <div class="label">达标时长：</div>
        <div class="value">{{ state.live.aaaaaa }}</div>
      </div>
      <div class="commonText">
        <div class="label">直播问答：</div>
        <div class="value">共{{ state.live.aaaaaa }}题</div>
      </div>
      <view v-if="state.live.question == 1" class="questionBox">
        <view v-if="state.showQuestion" class="questionList">
          <view
            class="groupItem"
            v-for="(item, idx1) in state.live.questionList"
            :key="idx1"
          >
            <view class="groupIndex">答卷{{ idx1 + 1 }}：</view>
            <view
              v-for="(item2, idx2) in item.list"
              :key="idx2"
              class="questionItem flex align-center justify-between"
            >
              <view class="flex align-center">
                <view class="qIndex fs0">问题{{ idx2 + 1 }}</view>

                <view class="qLabel">{{ item2.title }}</view>
              </view>
              <view class="flex align-center">
                <view class="qAnswer fs0">{{ item2.answer }}</view>

                <!-- <view class="qPoint fs0">{{ item.aaaaaaa }}</view> -->
              </view>
            </view>
          </view>
        </view>

        <view
          class="toggleShowQuestion flex align-center justify-center"
          @click="handleToggleShowQuestion"
        >
          <view class="iconBox" :class="state.showQuestion ? 'active' : ''">
            <van-icon
              v-if="state.showQuestion"
              name="arrow-down"
              color="#F16023"
              size="16px"
            />
            <van-icon wx:else name="arrow-up" color="#F16023" size="16px" />
          </view>
          <view class="text">
            {{ state.showQuestion ? "收起" : "展开" }}问题
          </view>
        </view>
      </view>
    </div>
  </div>
</template>

<script lang="ts" setup>
// --------------------------------------- 变量
const state = reactive({
  live: {},

  showQuestion: false,
});
// --------------------------------------- 方法、事件
onMounted(() => ({}));

function getStatus(status) {
  return { 1: "1", 20: "20", 30: "30", 40: "40" }[status] || "";
}

function handleToggleShowQuestion() {
  state.showQuestion = !state.showQuestion;
}
// --------------------------------------- 请求
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
.card {
  padding: 11px 14px;

  .title {
    height: 28px;
    font-family:
      PingFang SC,
      PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .status {
    height: 22px;
    font-family:
      PingFang SC,
      PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #999999;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .time {
    height: 22px;
    font-family:
      PingFang SC,
      PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    text-align: left;
    font-style: normal;
    text-transform: none;

    &.t1 {
      margin-top: 14px;
      margin-bottom: 8px;
    }
  }

  .commonText {
    display: flex;
    align-items: flex-start;
    &:not(:last-child) {
      margin-bottom: 14px;
    }

    .label {
      height: 22px;
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #666666;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .value {
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
}
</style>
